import React from 'react';
import ReactDOM from 'react-dom';
import App from './App'
import 'core-js/es';  
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'antd/dist/antd.css';
import './scss/common.scss';
import './scss/from.scss';
import './scss/order.scss';//订单样式
import '../common/scss/_icon_btn.scss';//各种icon小图标

import * as serviceWorker from '../serviceWorker';


import Http from '../common/service/http.js';
React.$http = Http;

ReactDOM.render(<App/>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
